import ApiService from "../../global/service";

export default class segmentationApiService {
    _getSegment = (values, requestHandler, errorHandler) => ApiService.get(`/pred/segments?age=${values.age}&zipcode=${values.zipcode}`, { "Access-Key": process.env.REACT_APP_ACCESS_KEY}, requestHandler, errorHandler)
 
}